import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css'],
})
export class HomePageComponent {
  name = '';
  email = '';
  file: File | null = null;

  isSubmitting = false;
  errorMsg = '';
  successMsg = '';

  // ✅ Backend URL (später per environment ersetzen)
  private apiUrl = 'https://api.noheroestcg.de/card-portal/api/submit';

  constructor(private http: HttpClient) {}

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    this.file = input.files?.[0] ?? null;
  }

  submit() {
    this.errorMsg = '';
    this.successMsg = '';

    if (!this.name || !this.email || !this.file) {
      this.errorMsg = 'Please fill in name, email and choose a file.';
      return;
    }

    if (!this.isValidXlsx(this.file)) {
      this.errorMsg = 'Only .xlsx files are allowed.';
      return;
    }

    const fd = new FormData();
    fd.append('name', this.name);
    fd.append('email', this.email);
    fd.append('file', this.file); // KEY muss "file" heißen (wie im Backend)

    this.isSubmitting = true;

    this.http.post<{ ok: boolean }>(this.apiUrl, fd).subscribe({
      next: () => {
        this.isSubmitting = false;
        this.successMsg = 'Submission sent! Please check your email.';
        // Optional: Reset
        this.name = '';
        this.email = '';
        this.file = null;
      },
      error: (err) => {
        this.isSubmitting = false;
        this.errorMsg =
          err?.error?.error ??
          'Submission failed. Please try again.';
        console.error(err);
      },
    });
  }

  private isValidXlsx(file: File): boolean {
    const validMime =
      file.type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

    const validExt = file.name.toLowerCase().endsWith('.xlsx');

    return validMime || validExt;
  }
}
